<template>
  <el-dialog
    title="提示"
    :visible.sync="dialog"
    top="29vh"
    width="500px"
    custom-class="custom-dialog"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div class="custom-dialog__content">
      <div class="title">
        <p>成果未到有效期或成果已有对接数据，如成果有对接数据则取消</p>
        <p>该数据的关联关系，确定要删除？</p>
      </div>
      <div class="sub-title">已有对接/已被加入工程的成果数据：</div>
      <div class="list">
        <el-scrollbar>
          <el-checkbox-group v-model="idList" class="checkbox">
            <el-checkbox
              v-for="(item, index) in dataList"
              :key="index"
              :label="item.id"
              >{{ item.name | lengthFilter(20) }}</el-checkbox
            >
          </el-checkbox-group>
        </el-scrollbar>
      </div>
      <div class="submit fn-text-center mt-20">
        <el-button type="primary" plain @click="handlerConfirm()"
          >确定</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    deleteList: {
      type: Array,
      required: true
    },
    relevanceList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialog: true,
      idList: this.deleteList,
      dataList: this.relevanceList
    };
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    handlerConfirm() {
      this.$emit("complete", this.idList);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .custom-dialog {
  .el-dialog__body {
    padding: 20px;
  }
  &__content {
    .title {
      line-height: 20px;
      text-align: center;
    }
    .sub-title {
      padding: 20px 30px 10px 30px;
      line-height: 20px;
      color: #666;
    }
    .list {
      height: 200px;
      padding: 0 30px;
      .checkbox {
        .el-checkbox {
          display: block;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
